<template>
  <div>
    <div class="mask">
      <Form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordRule">
        <div class="changePassword">
          <div class="changePassword-play">
            <div class="changePassword-p">
              <span class="password-p">{{$t('i.changePassword.password')}}</span>
              <span class="md-close" @click="closePassword">×</span>
            </div>
            <div class="phoneNumber">
              <div class="nationalAreaSpan">
                <span>{{$t('i.changePassword.cellPhoneNumber')}}</span>
              </div>
              <div class="nationalAreaSelect">
                <FormItem >
                  <Select v-model="changePasswordForm.areaVal">
                    <Option v-for="(list,index) in areaList" :key="index" :value="list.value">{{ list.label }}</Option>
                  </Select>
                </FormItem>
              </div>
              <div class="phoneNumberInput">
                <FormItem>
                  <i-input type="text" placeholder="phone" v-model="changePasswordForm.mobile">
                    <Icon type="md-phone-portrait" slot="prepend"/>
                  </i-input>
                </FormItem>
              </div>
            </div>

            <template v-for="(item,index) in pwdQuestionList">
              <div class="originalPassword">
                <div class="originalPasswordSpan">
                  <span>{{$t('i.login.pwdQuestion')}}{{index+1}}</span>
                </div>
                <div class="originalPasswordInput">
                  <p class="protectionText">{{item.title}}</p>
                </div>
              </div>

              <div class="originalPassword">
                <div class="originalPasswordSpan">
                  <span>{{$t('i.login.pwdAnswer')}}</span>
                </div>
                <div class="originalPasswordInput">
                  <i-input v-model="pwdQuestionList[index].answer"  placeholder="Password answer">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </i-input>
                </div>
              </div>
            </template>

            <div class="originalPassword">
              <div class="originalPasswordSpan">
                <span>{{$t('i.changePassword.originalPassword')}}</span>
              </div>
              <div class="originalPasswordInput">
                <FormItem prop="oldPassword">
                  <i-input type="password" placeholder="original Password" v-model="changePasswordForm.oldPassword">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </i-input>
                </FormItem>
              </div>
            </div>
            <div class="newPassword">
              <div class="newPasswordSpan">
                <span>{{$t('i.changePassword.newPassword')}}</span>
              </div>
              <div class="newPasswordInput">
                <FormItem prop="newPassword">
                  <i-input type="password" placeholder="new Password" v-model="changePasswordForm.newPassword">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </i-input>
                </FormItem>
              </div>
            </div>
            <div class="confirmPassword">
              <div class="confirmPasswordSpan">
                <span>{{$t('i.changePassword.confirmPassword')}}</span>
              </div>
              <div class="confirmPasswordInput">
                <FormItem prop="newPasswordC">
                  <i-input type="password" placeholder="confirm Password" v-model="changePasswordForm.newPasswordC">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </i-input>
                </FormItem>
              </div>
            </div>
            <div class="sure">
              <Button @click="saveUpdatePasswd('changePasswordForm')">{{$t('i.changePassword.preservation')}}</Button>
              <p style="color: red">{{$t('i.changePassword.title')}}</p>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js/crypto-js';
  import { mapState } from 'vuex';
  import { areaList } from '@/utils/area_zh_CN.js';

  export default {
    name: "changePassword",
    props:{
      changePasswordFormData: {},
      pwdQuestionList:{}
    },
    data () {
      const passwdCheck = (passwd,level) => {
        if(passwd == null || passwd == ""){
          return false;
        }
        var lev = "medium";
        var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
        var mediumRegex = new RegExp("^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
        var enoughRegex = new RegExp("(?=.{8,}).*", "g");
        if(level){
          lev = level;
        }
        if(lev == "high"){
          return strongRegex.test(passwd);
        }else if(lev == "medium"){
          return mediumRegex.test(passwd);
        }else if(lev == "low"){
          return enoughRegex.test(passwd);
        }else{
          return mediumRegex.test(passwd);
        }
      };
      const validateMobile = (rule, value, callback) =>{
        var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(value)) {
          callback(new Error('手机号码格式不正确！'));
        }else{
          callback();
        }
      };
      const validatePassword = (rule, value, callback) =>{
        if(!passwdCheck(value)){
          callback(new Error('密码复杂程度不够，请输入字母加数字，区分大小写！'));
        }else{
          callback();
        }
      };
      const validatePasswdC = (rule, value, callback) => {
        const newPassword = this.changePasswordForm.newPassword;
        if(value == newPassword){
          callback();
        }else{
          callback(new Error('两次密码不同，请重新输入！'));
        }
      };
      return {
        protection: '',
        areaList: areaList,
        changePasswordForm: {
          areaVal: '',
          mobile:  '',
          oldPassword: '',
          newPassword: '',
          newPasswordC: '',
        },
        changePasswordRule: {
          areaVal: [
            { required: true, message: this.$t('i.login.area'), trigger: 'change' }
          ],
          mobile: [// mobile: '请输入手机号',
            { required: true, message: this.$t('i.login.mobile'), trigger: 'blur' },
            { validator: validateMobile, trigger: 'blur' },
          ],
          oldPassword: [// oldPassword: '请输入原密码',
            { required: true, message: this.$t('i.login.oldPassword'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' },
          ],
          newPassword: [// newPassword: '请输入新密码',
            { required: true, message: this.$t('i.login.newPassword'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' },
            { validator: validatePassword, trigger: 'blur' },
          ],
          newPasswordC: [// newPasswordC: '请再输入新密码',
            { required: true, message: this.$t('i.login.newPasswordC'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' },
            { validator: validatePassword, trigger: 'blur' },
            { validator: validatePasswdC, trigger: 'blur' },
          ],
        }
      }
    },
    computed: {
      ...mapState({
       // areaList: (state) => state.areaList,
      }),
    },
    methods:{
      // async getArea(){
      //   const url = this.Constants.serverURL + "/area/area_zh_CN.json";
      //   const json = await this.RequestUtil.requestJson(url);
      //   this.areaList = eval(json);
      // },
      closePassword(){
        //初始密码或密码到期修改密码时，窗开被关闭后注销登录及情况本地存储
        const userInfo = localStorage.getItem("userInfo");
        let userInfoObj = null;
        if(userInfo){
          userInfoObj = JSON.parse(userInfo);
        }
        if(!userInfo || userInfoObj == null || userInfoObj.isInitPasswd == '1' || userInfoObj.passwdExpired == '1'){
          this.RequestUtil.request("/frontLogout");
          localStorage.removeItem("userInfo");
        }
        this.$emit('closeChangePasswd','0','0');
      },
      saveUpdatePasswd(name){
        this.$refs[name].validate(async (valid) => {

          let a = true
          let b = true

          if(this.changePasswordForm.mobile == '' || this.changePasswordForm.mobile == null ||
            this.changePasswordForm.areaVal == '' || this.changePasswordForm.areaVal == null){
              a = false
          }

          for(var i = 0 ;i<this.pwdQuestionList.length;i++){
            if(this.pwdQuestionList[i].answer == '' || this.pwdQuestionList[i].answer == null){
              b = false
              break;
            }
          }

          if(!a && !b){
              this.$Message.error({
              content: this.$t('i.login.pwdForgetMsg'),
              duration: 3,
              closable: true
            });
            return false
          }
          console.log("valid === " + valid);
          let flag = true;
          if (this.changePasswordForm.mobile != null && this.changePasswordForm.mobile != "") {
            flag = this.checkModbile(this.changePasswordForm.mobile);
          }
          if (valid && flag) {
            let url = "/frontUpdatePasswd?mobile=" + this.changePasswordForm.mobile;
            url += "&area=" + this.changePasswordForm.areaVal;
            url += "&oldPassword=" + CryptoJS.SHA256(this.changePasswordForm.oldPassword);
            url += "&newPassword=" + CryptoJS.SHA256(this.changePasswordForm.newPassword);
            url += "&newPasswordC=" + CryptoJS.SHA256(this.changePasswordForm.newPasswordC);
            const json = await this.RequestUtil.request(url,this.pwdQuestionList);
            if(json) {
              if (json.statusCode == this.Constants.statusCode.ok) {
                this.$Message.success(json.message);
                //this.$emit('closeChangePasswd','0','0');
                setTimeout(() => {
                  window.location.href = this.Constants.serverURL;
                  // this.$router.push({name:'login'})
                  // this.$router.go(0);
                },1000);
              }
            }
          }
        });
      },
      checkModbile(mobile) {
        var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
        var result = re.test(mobile);
        if(!result) {
          this.$Message.error({
            content: this.$t('手机号码格式不正确！'),
            duration: 3,
            closable: true
          });
          return false;
        }
        return true;
      }
    },
    watch: {
      changePasswordFormData: function (val) {
        if(this.changePasswordFormData != null){
          this.changePasswordForm.areaVal = this.changePasswordFormData.area;
          this.changePasswordForm.mobile = this.changePasswordFormData.mobile;
        }
      },
    },
    mounted(){
      // this.getArea();
    }
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  /*.changePassword{*/
    /*width: 100%;*/
    /*height: 600px;*/
  /*}*/
  .changePassword-play{
    width: 800px;
    height: 600px;
    margin: 70px auto 0 auto;
    border-radius: 20px;
    border: 2px solid #ccc;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .changePassword-p{
    width: 800px;
    height: 60px;
    text-align: center;
    font-size: 40px;
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .md-close{
    font-size: 45px;
    float: right;
    margin-right: 30px;
    line-height: 50px;
    cursor: pointer;
    color: #2d8cf0;
  }

  .phoneNumber{
    width: 800px;
    height: 45px;
    margin-bottom: 20px;
  }

  .nationalAreaSpan{
    width: 210px;
    height: 32px;
    float: left;
    text-align: right;
    line-height: 32px;
  }
  .nationalAreaSelect{
    width: 190px;
    height: 32px;
    float: left;
    margin-right: 20px;
  }
  .phoneNumberInput
  {
    width: 190px;
    height: 32px;
    float: left;
  }

  .originalPassword,
  .newPassword,
  .confirmPassword
  {
    width: 800px;
    height: 45px;
    margin-bottom: 20px;

  }
  .nationalAreaSpan,
  .originalPasswordSpan,
  .newPasswordSpan,
  .confirmPasswordSpan
  {
    width: 210px;
    height: 32px;
    float: left;
    text-align: right;
    line-height: 32px;
    margin-right: 5px;
  }
  .originalPasswordInput,
  .newPasswordInput,
  .confirmPasswordInput
  {
    width: 400px;
    height: 30px;
    float: left;
  }
  .protectionText{
    line-height: 30px;
  }
  .sure{
    width: 750px;
    height: 100px;
    margin: 0 auto;
    text-align: center;
  }
  .sure button{
    width: 400px;
    height: 30px;
    font-size: 18px;
    background-color: #26a2ff;
    border-radius: 5px;
    margin-bottom: 18px;
    padding: 0;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/changePassword/changePassword.vue